import { IamProviderType } from '@1po/1po-bff-fe-spec/generated/backoffice/central_settings/model/IamProviderType';
import { DEFAULT_IAM_PROVIDER } from 'domains/centralSettings/CentralSettings.types';

export interface OtherBrandCatalogType {
  iamProvider: IamProviderType;
  name: string;
}

export const otherBrandCatalogData: OtherBrandCatalogType[] = [
  {
    iamProvider: 'RENAULT' as IamProviderType,
    name: 'RENAULT',
  },
  {
    iamProvider: 'MOTRIO' as IamProviderType,
    name: 'MOTRIO',
  },
];

export const getOtherBrandCatalogByIamProvider = (iamProvider: IamProviderType): OtherBrandCatalogType => {
  const found = otherBrandCatalogData.find((item) => item.iamProvider === iamProvider);
  if (!found) {
    throw new Error(`No other brand catalog found for IAM provider: ${iamProvider}`);
  }
  return found;
};

export const DEFAULT_OTHER_BRAND_CATALOG = getOtherBrandCatalogByIamProvider(DEFAULT_IAM_PROVIDER);
